import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useContent } from './ContentContext';
import { useTranslation } from './LanguageContext';
import { useUI } from './UIContext';
import DemoVideoPlayer from './DemoVideoPlayer';
import { getDemoVideoUrl } from '../utils/demoVideo';
import 'animate.css';
import defaultHeroBg from '../img/herosBG.jpeg';

export default function Hero() {
  const { t, lang } = useTranslation();
  const { showModal } = useUI();

  const title = t('hero.titleDefault');
  const subtitle = t('hero.subtitleExplicit');
  const benefit = t('hero.benefit');
  const demoVideoSrc = useMemo(() => getDemoVideoUrl(), []);
  const bg = defaultHeroBg;

  const openDemoModal = () => {
    showModal({
      title: t('hero.demoCta'),
      closeLabel: lang === 'fr' ? 'Fermer la fenetre de demonstration' : 'Close demo dialog',
      containerClassName: 'modal-container--video',
      bodyClassName: 'modal-body--video',
      content: (
        <DemoVideoPlayer
          src={demoVideoSrc}
          title={t('demo.title')}
          autoPlay
          className="modal-video-frame"
        />
      ),
    });
  };

  return (
    <section
      id="home"
      className="hero"
      style={{
        backgroundImage: `url(${bg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="container text-center">
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={t('hero.metaDescription')} />
          <link rel="canonical" href="https://fecanalytics.org/" />
          <meta property="og:title" content={t('hero.metaTitle')} />
          <meta property="og:description" content={t('hero.metaDescription')} />
          <meta property="og:image" content="https://fecanalytics.org/og-image.jpg" />
          <meta property="og:url" content="https://fecanalytics.org/" />
        </Helmet>
        {/* Animation du titre */}
        <h1 className="animate__animated animate__fadeInDown animate__slow animate__delay-250ms font-extrabold">
          {title}
        </h1>

        {/* Animation du sous-titre avec un leger delai animate__fadeInUp*/}
        <p
          className="animate__animated animate__fadeInDown animate__slow animate__delay-250ms"
          style={{ fontSize: '1.2rem', marginTop: '1rem', color: 'var(--bg)', fontWeight: 600 }}
        >
          {subtitle}
        </p>
        <p
          className="animate__animated animate__fadeInDown animate__slow animate__delay-250ms"
          style={{ fontSize: '1rem', marginTop: '0.5rem', fontWeight: 700, color: 'var(--color-accent)' }}
        >
          {benefit}
        </p>

        {/* Animation des boutons */}
        <div
          className="hero-buttons animate__animated animate__fadeInUp animate__delay-200ms"
          style={{ marginTop: '2rem', alignItems: 'center', display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}
        >
          <Link to="/analyse" className="btn-analyse btn btn-primary">
            <strong>{t('hero.cta')}</strong>
          </Link>
          <button type="button" className="btn btn-outline" onClick={openDemoModal}>
            <strong style={{ color: 'var(--bg)', borderColor: 'var(--bg)' }}>{t('hero.demoCta')}</strong>
          </button>
        </div>
      </div>
    </section>
  );
}
